export default __webpack_public_path__ + "static/media/right.84171573.gif";